<template>
  <div class="flex h-full">
    <!-- Sidebar -->
    <gym-sidebar
      :gyms="gyms"
      :selected-gym="selectedGym"
      :loading="loading"
      @select="selectGym"
      @search="handleSearch"
      class="w-80 flex-shrink-0 border-r-2 border-neutral-900 overflow-y-auto" />

    <!-- Map -->
    <div class="flex-1 relative">
      <map-view
        ref="mapView"
        :mapbox-token="mapboxToken"
        :gyms="gyms"
        :selected-gym="selectedGym"
        @marker-click="selectGym"
        @map-click="clearSelection" />

      <!-- Detail Panel -->
      <gym-detail-panel
        v-if="selectedGym"
        :gym="selectedGym"
        @close="clearSelection"
        @approve="approveGym"
        @reject="rejectGym"
        class="absolute top-4 right-4 w-96" />
    </div>
  </div>
</template>

<script>
import { fetchGyms, approveGym as apiApproveGym, rejectGym as apiRejectGym } from '~/javascript/api/gyms'
import MapView from './components/map_view.vue'
import GymSidebar from './components/gym_sidebar.vue'
import GymDetailPanel from './components/gym_detail_panel.vue'

export default {
  name: 'GymMap',

  components: {
    MapView,
    GymSidebar,
    GymDetailPanel
  },

  props: {
    mapboxToken: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      gyms: [],
      selectedGym: null,
      loading: false,
      searchQuery: ''
    }
  },

  mounted() {
    this.loadGyms()
  },

  methods: {
    async loadGyms() {
      this.loading = true
      try {
        const params = { all: 'true' }
        if (this.searchQuery) params.search = this.searchQuery
        const data = await fetchGyms(params)
        this.gyms = data.gyms || []
      } catch (error) {
        console.error('Failed to load gyms:', error)
      } finally {
        this.loading = false
      }
    },

    selectGym(gym) {
      this.selectedGym = gym
      if (this.$refs.mapView && gym.latitude && gym.longitude) {
        this.$refs.mapView.flyTo(gym.longitude, gym.latitude)
      }
    },

    clearSelection() {
      this.selectedGym = null
    },

    handleSearch(query) {
      this.searchQuery = query
      this.loadGyms()
    },

    async approveGym(gym) {
      try {
        await apiApproveGym(gym.id)
        gym.status = 'approved'
      } catch (error) {
        console.error('Failed to approve gym:', error)
      }
    },

    async rejectGym(gym) {
      try {
        await apiRejectGym(gym.id)
        gym.status = 'rejected'
      } catch (error) {
        console.error('Failed to reject gym:', error)
      }
    }
  }
}
</script>
